import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface TextareaReactQuillProps {
  state: string;
  setState: React.Dispatch<React.SetStateAction<string>>;
}

export default function TextareaReactQuill({
  state,
  setState,
}: TextareaReactQuillProps) {
  const ReactQuillModules = {
    toolbar: [
      [
        { header: "1" },
        { header: "2" },
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
        "link",
      ],
      [{ font: [] }, { size: [] }, "clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const ReactQuillFormarts = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  return (
    <ReactQuill
      id="textarea-react-quill"
      value={state}
      onChange={(value) => setState(value)}
      theme="snow"
      modules={ReactQuillModules}
      formats={ReactQuillFormarts}
    />
  );
}
